import React, { useState } from 'react';
import { Modal, ModalHeader, ModalBody, ModalFooter, Button } from 'reactstrap';

import axios from '../../../axios';
import * as url from '../../../utils/url';
import { toastContainer } from '../../../utils/toast';
import { withHashtagPrefix } from '../../../utils/hashtagPrefix';

// Performs the delete PATCH itself; SmsRoutingModal syncs its list state via onDeleted().
const DeleteHashtagModal = ({ isOpen, onClose, hashtag, prefix, onDeleted }) => {
    const [isDeleting, setIsDeleting] = useState(false);

    const displayName = hashtag ? withHashtagPrefix(hashtag.name, prefix) : '';

    const handleConfirmDelete = () => {
        if (!hashtag) return;

        if (!hashtag._id) {
            // Never persisted server-side (e.g. an unconfigured default) —
            // nothing to delete remotely.
            onDeleted(hashtag);
            return;
        }

        setIsDeleting(true);
        axios.patch(url.textifyUpdateGroupStatus(hashtag._id), { status: 'inactive' })
            .then(() => {
                toastContainer('Hashtag deleted.', 'success');
                onDeleted(hashtag);
            })
            .catch((err) => {
                const errMsg = (err.response && err.response.data && err.response.data.message) || (err.response && err.response.data && err.response.data.error) || 'Failed to delete hashtag.';
                toastContainer(errMsg, 'error');
            })
            .finally(() => setIsDeleting(false));
    };

    return (
        <Modal isOpen={isOpen} toggle={isDeleting ? undefined : onClose} centered className="bwai-modal delete-hashtag-modal">
            <ModalHeader className="bwai_modal_header" toggle={isDeleting ? undefined : onClose}>
                <span className="bwai_title_block">
                    <span className="bwai_title_text">Delete hashtag #{displayName}?</span>
                </span>
            </ModalHeader>
            <ModalBody className="p-3">
                <p style={{ fontSize: '14px', color: '#64748b', lineHeight: 1.6, margin: 0 }}>
                    This will remove #{displayName} and route its conversations to the deleted items bin. You can recover the hashtag and its conversations later from 'Recover deleted'.
                </p>
            </ModalBody>
            <ModalFooter className="bwai_popup_footer">
                <Button className="bwai_btn_outline" onClick={onClose} disabled={isDeleting}>
                    Cancel
                </Button>
                <Button className="bwai_btn_danger" onClick={handleConfirmDelete} disabled={isDeleting}>
                    {isDeleting ? 'Deleting...' : 'Delete hashtag'}
                </Button>
            </ModalFooter>
        </Modal>
    );
};

export default DeleteHashtagModal;
